class LineItems extends HTMLElement {
  section =
    window.location.pathname === `${Shopify.routes.root}cart`
      ? 'fetch-line-items-cart-page'
      : 'fetch-line-items';
  connectedCallback() {
    this.unsubscribeCartChange = subscribe('cart:change', ({ line, quantity }) =>
      this.cartChange(line, quantity)
    );
    this.unsubscribeRefreshCart = subscribe('cart:added', () => this.refreshCart());
  }

  disconnectedCallback() {
    this.unsubscribeCartChange();
    this.unsubscribeRefreshCart();
  }

  /**
   * Change the cart.
   * @description Use the /{locale}/cart/change.js endpoint to change the quantity, properties, and selling_plan properties of a cart line item. Only items already in your cart can be changed, and you can change only one line item at a time.
   * @tutorial https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
   */
  async cartChange(line, quantity) {
    publish('cart:updating', {
      line,
    });

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.section,
      sections_url: window.location.pathname,
    });

    try {
      const { error, data } = await this.fetchCart(routes.cart_change_url, body);

      if (error) throw new Error(error);
      this.renderSections(data.sections);

      publish('cart:updated', {
        itemCount: data.item_count,
      });

      window.toast.success('Cart updated');
    } catch (error) {
      console.error(error);
      window.toast.error(error.message);

      publish('cart:error', {
        line,
      });
    }
  }

  /**
   * Fetch the cart.
   * @param {string} input - The URL to fetch.
   * @param {string} body - The request body.
   * @returns {Promise} The response.
   *
   * @example
   * const json = await this.fetchCart(routes.cart_change_url, body);
   */
  async fetchCart(input, body) {
    const response = await fetch(input, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body,
    });

    const data = await response.json();

    if (!response.ok) return { error: data.errors, data: null };

    return { error: null, data };
  }

  /**
   * Refresh the cart.
   */
  async refreshCart() {
    console.log('cart:added');
    try {
      const response = await fetch(`${Shopify.routes.root}?sections=${this.section}`);
      const data = await response.json();

      const sections = {};
      sections[this.section] = data[this.section];

      publish('cart:updated', {
        itemCount: data.item_count,
      });

      this.renderSections(sections);
    } catch (error) {
      window.toast.error(error.message);
    }
  }

  /**
   * Render the sections.
   * @param {Object} json - The JSON response.
   * @example
   * const json = await this.fetchCart(routes.cart_change_url, body);
   * this.renderSections(json);
   */
  renderSections(sections) {
    const html = new DOMParser().parseFromString(sections[this.section], 'text/html');
    this.innerHTML = html.querySelector('line-items').innerHTML;
  }
}

customElements.define('line-items', LineItems);
